export const pageMargin = '@page { margin: 15mm!important; }';
